<template>
  <v-form ref="form" >

    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>
      <!-- se for de colheita, só lista todos -->
      <v-col cols="12">
        <v-autocomplete
          v-model="entry.itemId"
          v-bind="getObject('itemId')"
          label="Item"
          :items="extraData.accountContext.availableEndProductsForCroppingInPlanningOperation"
          item-value="id"
          item-text="name"
          @input="selectItem"
          :hint="entry.item ? ( 'Unidade de Produção: ' + entry.item.unit.name + (entry.item.brand ? ', Marca: ' + entry.item.brand.name : '')) : ''"
          persistent-hint
          autocomplete="off"
          :disabled="readOnly"
        >
          <template v-slot:item="data">
            <v-list-item-content>
              <v-list-item-title>{{data.item.name}}</v-list-item-title>
              <v-list-item-subtitle>Unidade de Produção: {{data.item.unit.name}} {{data.item.brand ? ', Marca: ' + data.item.brand.name : ''}}</v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6" >
        <v-autocomplete
          v-model="entry.storageId"
          v-bind="getObject('storageId')"
          label="Depósito"
          :items="extraData.accountContext.allStorages"
          item-value="id"
          item-text="name"
          @input="selectStorage"
          :hint="entry.storehouse ? 'Localização: ' + (entry.storage.location ? entry.storage.location : 'não informada') : '' "
          persistent-hint
          autocomplete="off"
          :disabled="readOnly"
        >
          <template v-slot:item="data">
            <v-list-item-content>
              <v-list-item-title>{{data.item.name}}</v-list-item-title>
              <v-list-item-subtitle>Localização: {{data.item.location ? data.item.location : 'não informada'}}</v-list-item-subtitle>
            </v-list-item-content>
          </template>

           <template v-slot:append-outer>
            <StorehouseNew
              :inlineAddButton="true"
              @entry-created="storehouseCreated"
            />
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="10" sm="6">
        <MaskedTextField
          v-if="renderComponent"
          v-bind="getObject('quantity')"
          :inputData.sync="entry.quantity"
          mask-type="currency"
          label="Quantidade Produzida"
          :suffix="entry.item ? entry.item.unit.name : ''"
          :disabled="!entry.storageId || readOnly"
          autocomplete="off"
          :hint="entry.item && false ? (entry.item.cropLimit >= 0 ? 'O limite máximo de colheita é de ' + numberToDecimal(entry.item.cropLimit) + ' Unid.': '') : ''"
          persistent-hint
        />
      </v-col>

      <v-col cols="12" sm="6">
        <MaskedTextField
          v-if="renderComponent"
          v-bind="getObject('expectedUnitPrice')"
          :inputData.sync="entry.expectedUnitPrice"
          mask-type="currency_10d"
          label="Preço Estimado de Venda Unit."
          prefix="R$"
          :suffix="entry.item ? entry.item.unit.name : ''"
          :key="expectedUnitPriceKey + 'expectedUnitPrice'"
          @update:inputData="changeExpectedUnitPrice"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <!-- preço total -->
      <v-col cols="12" sm="6">
        <MaskedTextField
          v-if="renderComponent"
          v-bind="getObject('price')"
          :inputData.sync="entry.price"
          mask-type="currency"
          label="Preço Estimato Total de Venda"
          prefix="R$"
          :disabled="true"
          :key="expectedTotalPriceKey + 'expectedTotalPrice'"
          autocomplete="off"
        />
      </v-col>

    </v-row>
  </v-form>
</template>

<script>
import MultiSelect from "@shared_components/multi_select.vue";
import MaskedTextField from "@shared_components/masked_text_field.vue"
import gql from 'graphql-tag'
// import StorehouseNew from "@models/storehouses/new.vue"
import BaseUtil from "@shared_components/base_util.vue";

export default {
  data() {
    return {
      entryAttributes: {},
      endProductsList: [],
      endProductsListLoading: false,
      packagingListLoading: false,
      packagingList: [],
      renderComponent: true,
      expectedUnitPriceKey: 0,
      expectedTotalPriceKey: 0,
      pageLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
    originalEntry: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
  },
  components: {
    MultiSelect: MultiSelect,
    MaskedTextField: MaskedTextField,
    BaseUtil: BaseUtil,
    // StorehouseNew: StorehouseNew
  },
  beforeCreate: function () {
    this.$options.components.StorehouseNew = require('@models/storehouses/new.vue').default
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
    // console.log("consumed item", this.entry.item)
    if (this.entry.item) {
      this.selectItem();
    }
  },
  mounted() {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
    selectItem: function() {
      this.entry.item = this.extraData.accountContext.availableEndProductsForCroppingInPlanningOperation.find(obj => obj.id == this.entry.itemId);

      if (!this.entry.storageId && this.extraData.accountContext.allStorages.length == 1) {
        this.entry.storageId = this.extraData.accountContext.allStorages[0].id;
        this.selectStorage(); 
      }

      // console.log("this.entry.item.cropLimit", this.entry.item.cropLimit)
      if (this.entry.item && (this.entry.item.cropLimit != null || this.entry.item.cropLimit == 0)) {
        this.entryAttributes.quantity.rules = [];
        this.entryAttributes.quantity.rules.push(this.requiredRule);
        this.entryAttributes.quantity.rules.push(this.minRequiredRule);
        let limitQuantity = _.round(this.entry.item.cropLimit, 2);
        // usado para contabilizar a quantidade já salva no edit
        if (this.isEdit) {
          limitQuantity = _.round(this.entry.item.cropLimit + this.originalEntry.quantity, 2);
        }
        this.entryAttributes.quantity.rules.push(this.maxValueRule(limitQuantity));
        this.entry.item.cropLimit = limitQuantity;
      }
    },
    selectStorage: function() {
      this.entry.storage = this.extraData.accountContext.allStorages.find(obj => obj.id == this.entry.storageId);
    }, 
    clearFields: function() {
      this.forceRerender(this);
    },
    storehouseCreated: function(storage) {
      this.extraData.accountContext.allStorages.unshift(storage);
      this.entry.storageId = storage.id;
      this.entry.storage = storage;
    },
    changeExpectedUnitPrice: function() {
      if (this.entry.quantity > 0) {
        this.entry.price = _.round((this.entry.expectedUnitPrice ? this.entry.expectedUnitPrice : 0) * (this.entry.quantity ? this.entry.quantity : 0), 2);
        this.expectedTotalPriceKey++;
      }
    },
  }
};

</script>

<style scoped></style>
